import { View } from 'mappMvc/models/views';
import { Header, LoginUser } from 'mappMvcStudio/app';
import { MAppSection } from '../models/mapps';
import { Studio } from '../studio';
import { ID } from 'mappMvc/const';
import { Templates } from '../../compile';
import { IView } from 'mappMvc/interfaces';
import { ViewOptions } from 'mappMvc/interfaces/options';

export class StudioSection extends View {
	public header: Header;
	public mappsSection: MAppSection;
	private user: LoginUser;

	constructor(studio: Studio, user: LoginUser) {
		super(<ViewOptions>{
			viewId: ID.Dynamic,
			template: Templates.layouts_main,
			navigationLayout: Templates.header_navigation_bar
		});

		this.user = user;

		//Header
		this.header = new Header(this.user);

		/**
		 * Views
		 */
		var views: IView[] = [];

		//Mapps
		this.mappsSection = new MAppSection();
		views.push(this.mappsSection);

		//init
		this.defaultView = this.mappsSection;
		this.isVirtualView = true;
		this.initViews(views);
	}

	//overwrite
	public activated(routeSections: string[]) {
		super.activated(routeSections);
		this.user.updateUserInfo();
	}
}
